import React, { useEffect, useRef } from "react";
import Icon from "./Icon";

// ponytail: copy of the website's Terms (pluginlive-designs website
// src/app/(marketing)/terms/page.tsx — the page www.pluginlive.com/terms serves).
// Ceiling: edits to the site's terms don't reach this copy. Upgrade: serve the
// terms from one shared source both the site and this dialog read.
const TERMS = [
  "By accessing or using any services provided by PluginLive Technologies Pvt Ltd or its affiliates, you agree to be bound by these Terms and Conditions.",
  "Your use of our services is voluntary, and you have the option to discontinue at any time. Any personal information you provide to us is voluntary, and you will not be subject to adverse consequences if you choose not to provide it. However, certain services may require the use of personal information for functionality.",
  "We may seek your consent to collect, hold, use, and disclose your personal information for purposes outlined in our Privacy Policy or any other lawful purposes. You agree to provide accurate and up-to-date information when using our services and to maintain the confidentiality of any account credentials or passwords associated with our services.",
  "You agree not to engage in any unlawful or unauthorized activities when using our services, and we reserve the right to modify, suspend, or terminate any part of our services at any time without prior notice. We are not liable for any damages or losses resulting from your use of our services, including but not limited to, direct, indirect, incidental, or consequential damages.",
  "These Terms and Conditions constitute the entire agreement between you and PluginLive Technologies Pvt Ltd regarding your use of our services and supersede any prior agreements or understandings.",
  "If you have any questions or concerns regarding these Terms and Conditions, please contact us at contact@pluginlive.com.",
];

/** Terms & Conditions in a pop-up, so signing in never sends the user to another tab. */
export default function TermsDialog({ open, onClose }) {
  const ref = useRef(null);

  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (open && !d.open) d.showModal();
    else if (!open && d.open) d.close();
  }, [open]);

  return (
    <dialog
      ref={ref}
      className="contact-dialog terms-dialog"
      aria-labelledby="terms-title"
      onClose={onClose}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="cd-head">
        <h2 id="terms-title">Terms &amp; Conditions</h2>
        <button type="button" className="cd-close" aria-label="Close" onClick={onClose}>
          <Icon name="close" />
        </button>
      </div>
      <div className="cd-body terms-body">
        <p className="cd-sub">Agreement to Terms of Service</p>
        {TERMS.map((t) => <p key={t.slice(0, 24)}>{t}</p>)}
      </div>
      <div className="cd-foot">
        <button type="button" className="auth-btn auth-btn-primary" onClick={onClose}>Close</button>
      </div>
    </dialog>
  );
}

/** "Terms & Conditions" link that opens the terms pop-up in place. */
export function TermsLink({ className = "link", children = "Terms & Conditions" }) {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <button type="button" className={className} aria-haspopup="dialog" onClick={() => setOpen(true)}>
        {children}
      </button>
      <TermsDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
}
